/* naawm / Nox — barre d'achat collante mobile.
   S'affiche quand le CTA principal de la buy box sort de l'écran (par le haut). */
(function () {
  if (window.__noxSticky) return;
  window.__noxSticky = true;

  function init() {
    document.querySelectorAll('.nox-sticky:not(.nox-sticky--armed)').forEach(function (bar) {
      bar.classList.add('nox-sticky--armed');
      var section = bar.closest('.nox-bb');
      if (!section) return;
      var target = section.querySelector('.nox-bb__form') || section;

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var passedAbove = entry.boundingClientRect.top < 0;
            var show = !entry.isIntersecting && passedAbove;
            bar.classList.toggle('nox-sticky--visible', show);
            bar.setAttribute('aria-hidden', show ? 'false' : 'true');
          });
        },
        { threshold: 0 }
      );
      io.observe(target);
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
